import { Guid } from 'guid-typescript';

export class ProductModel {
  id: Guid;
  name: string;
}
